import './polyfills/polyfills';
import { initBehaviors } from '../shared/utilities/behaviors';

initBehaviors();
